import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserOrderContext } from 'context/context';
import ImageComponent from 'atoms/Image/index';
import { Row, Col } from 'reactstrap';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { Link } from 'react-scroll';
import MobSearchIcon from 'styles/staticAssets/images/mobileSearch.svg';
import MenuItemList from './MenuItemList';
import MenuSubCategoryItemList from './MenuSubCategoryItemList';
import View_1UP_Icon from 'styles/staticAssets/images/View_1UP_Icon.svg';
import View_1UP_Icon_Inactive from 'styles/staticAssets/images/View_1UP_Icon_Inactive.svg';
import View_carousal_Icon from 'styles/staticAssets/images/View_carousal_Icon.svg';
import View_carousal_Icon_Inactive from 'styles/staticAssets/images/View_carousal_Icon_Inactive.svg';
import { ReactSVG } from 'react-svg';
import {
  BACK_TO_MENU,
  CLEAR_ALL,
  CLEAR_SEARCH,
  MENU_PLP_CONSTANT,
  TURNED_NO_RESULTS_TEXT,
  WE_FOUND_TEXT,
  YOUR_SEARCH_TEXT,
  CAROUSAL,
  VIEWUP,
  CATEGORY_ID
} from '../MenuPLPConstants/MenuPLPConstants';
import {
  isEmptyObject,
  notHiddenProductsCount,
  filterNotHiddenItem,
  isEmptyEvery,
  getDispositionTypeOnAPIFormat,
  getTernaryValue,
  getAndCheck,
  getEmptyObjectforNull,
} from 'common/utilities/utils';
import MobSearchFilterMenu from './MobSearchFilterMenu';
import DarkCloseButton from 'styles/staticAssets/images/Darkclosebutton.svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  setAnalyticsDataFilter,
  filterRecommendations,
  getAnalytictsPayloadConditionaly,
  vieItemListAnalytics,
  getCategoryFromSubCategory,
  menuNavigationAnalyticsData,
  getCategory,
  OnSerchElmnt,
} from '../MenusPlpUtilities/MenusPlpUtils';

import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import Cart_Error from 'styles/staticAssets/images/Cart_Error.svg';

export const filterNotHiddenItemWithProducts = menulist => {
  const { menu, handleSetActive, menuNavigation } = menulist;
  return menu.map(({ id, isHidden, url, name, dname, subcategory }, index, item) => {
    return (
      !isHidden &&
      item[index].products.length > 0 && (
        <li key={id}>
          <Link
            data-testid='category-click-test-mob'
            to={name.trim()}
            onClick={() => menuNavigation(name.trim(), url)}
            spy={true}
            offset={-100}
            smooth={false}
            activeClass={'active'}
            onSetActive={handleSetActive}
          >
            {dname[0].value}
          </Link>
        </li>
      )
    );
  });
};

export const categoriesMenuItems = categoriesItem => {
  const {
    categoriesList,
    carouselCount,
    visibleProductsCount,
    renderItemList,
    viewCarousal,
    viewUp,
    changeViewtoUp,
    changeViewtoCarousal,
  } = categoriesItem;
  return categoriesList
    .filter(({ isHidden }) => !isHidden)
    .map(
      (
        {
          id,
          name,
          dname,
          imageName,
          products,
          categories,
          isHidden,
          displayOrder,
          specials,
          exclusive,
          timer,
          discount,
          url,
        },
        index,
      ) => {
        const categoryDetails = {
          categoryId: id,
          categoryName: name.trim(),
          categoryUrl: url,
        };
        return (
          !isHidden &&
          products.length > 0 && (
            <div
              id={name.trim()}
              className={index === 0 || viewCarousal ? 'carousal-menu-container' : 'small-menu-container'}
            >
              {visibleProductsCount > 1 && index === 1 && (
                <div>
                  <div className='product-view-section'>
                    <span className='product-view'>{translateWithI18Next(MENU_PLP_CONSTANT.PRODUCT_VIEW_TEXT)}:</span>
                    <ReactSVG
                      src={viewUp ? View_1UP_Icon : View_1UP_Icon_Inactive}
                      className='product-view-up-icon'
                      onClick={changeViewtoUp}
                      data-testid='change-view-to-up'
                    />
                    <ReactSVG
                      src={viewCarousal ? View_carousal_Icon : View_carousal_Icon_Inactive}
                      className='product-view-carousal-icon'
                      onClick={changeViewtoCarousal}
                      data-testid='change-view-to-carousal'
                    />
                  </div>
                  <hr className='product-view-divider'></hr>
                </div>
              )}
              <div className='d-flex position-relative'>
                <div className='small-category-name'>{dname[0].value}</div>
                {!viewUp && (
                  <div className='card-counter'>
                    {carouselCount}/{visibleProductsCount}
                  </div>
                )}
              </div>
              {index === 0
                ? renderItemList(products, categories, CAROUSAL, categoryDetails)
                : renderItemList(products, categories, VIEWUP, categoryDetails)}
            </div>
          )
        );
      },
    );
};

export const MobMenusPlpItem = ({
  data,
  tenantData,
  filterList,
  dietaryList,
  sortByListMob,
  sortByOptions,
  handleClearItems,
  handleFilteredData,
  handleSearchdata,
  tempData,
  recommendations,
  catalogs,
  selectedCat,
  storeClosedData,
  triggerGetRecommends,
  setShowTopScrollBtn,
}) => {
  const history = useHistory();
  const mobileSearchFilterMenuRef = useRef();
  const { userOrderState } = useContext(UserOrderContext);
  const [searchMode, setSearchMode] = useState({ isSearchedMode: false, searchedData: '' });
  const [hideTopRow, setHideTopRow] = useState(false);
  const [inputSearchData, setInputSearchValue] = useState(false);
  const [activeMenuSelection, setActiveMenuSelection] = useState('');
  const [menuGtmEventTriggered, setmenuGtmEventTriggered] = useState('');

  let { menu, categories, products } = {};
  if (Object.keys(tempData).length) {
    ({ menu, categories, products } = getEmptyObjectforNull(tempData));
  } else {
    ({ menu, categories, products } = getEmptyObjectforNull(data));
  }
  const visibleProductsCount = notHiddenProductsCount(products);
  const [recommendProducts, setReccomendedProducts] = useState([]);
  const [viewUp, setViewUp] = useState(true);
  const [viewCarousal, setViewCarousal] = useState(false);
  const [carouselCount, setCarouselCount] = useState(1);
  const [categoryStatusMobile, setCategoryStatusMobile] = useState(false);
  const [paramValueMobile, setParamValueMobile] = useState(false);
  const tenantReducer = useSelector(data => data.tenantReducer);

  const { category_name } = useParams();

  const dispositionNewMobile = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const params = useMemo(() => {
    return {
      tenantReducer: isEmptyObject(tenantReducer) ? tenantReducer : JSON.parse(localStorage.getItem('tenantReducer')),
      storeInfo: dispositionNewMobile ? dispositionNewMobile.store : {},
      dispositionType:
        dispositionNewMobile && dispositionNewMobile.type
          ? getDispositionTypeOnAPIFormat(dispositionNewMobile.type)
          : getDispositionTypeOnAPIFormat(tenantReducer?.authoredContent?.defaultdisposition),
    };
  }, [dispositionNewMobile, tenantReducer]);

  const { dispositionType } = params;

  const handleClose = () => {
    setCategoryStatusMobile(false);
    history.push({
      pathname: '/menu',
    });
  };

  useEffect(() => {
    getCategory(categories, category_name, setParamValueMobile, setCategoryStatusMobile, true);
    // eslint-disable-next-line
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (data?.products?.length && searchMode.isSearchedMode && recommendations?.length) {
      let recommentProdArr = filterRecommendations(data?.products, recommendations);
      setReccomendedProducts(recommentProdArr);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchMode.searchedData, recommendations]);

  useEffect(() => {
    if (searchMode.searchedData) {
      triggerGetRecommends(searchMode.searchedData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchMode.searchedData]);

  const changeViewtoUp = () => {
    setViewUp(true);
    setViewCarousal(false);
  };
  const changeViewtoCarousal = () => {
    setViewCarousal(true);
    setViewUp(false);
  };
  const getCardCount = count => {
    setCarouselCount(count);
  };

  const openSearchFilterMenu = () => {
    mobileSearchFilterMenuRef.current.style.width = '100%'; // show filter modal
    setHideTopRow(true);
  };

  const setSearchModeSet = (flag, val) => {
    setSearchMode({ isSearchedMode: flag, searchedData: val });
  };

  const clearSearch = () => {
    setInputSearchValue('');
    handleSearchdata();
    setSearchMode({ isSearchedMode: false, searchedData: '' });
  };

  const closeSearchFilterMenu = value => {
    // if (value === 'Close') {
    //   handleClearItems(null); // to clear all the filter choosen
    // }
    // analytics event triggers
    setAnalyticsDataFilter(
      {
        eventType: 'filterItems',
        selectedData: {
          filterSelected: filterList.length > 0 ? filterList.join() : 'none',
          dietarySelected: dietaryList.length > 0 ? dietaryList.join() : 'none',
          sortSelected: sortByOptions.find(i => i.selected)?.name ? sortByOptions.find(i => i.selected).name : 'none',
        },
      },
      'filterSelected',
      'dietarySelected',
      'sortSelected',
    );
    mobileSearchFilterMenuRef.current.style.width = '0'; // hide filter modal
    setHideTopRow(false);
  };

  useEffect(() => {
    const scrollEventListener = () => {
      const mobSearchInput = document.getElementById('mob-searchinput-id')?.style;
      if (mobSearchInput) {
        const isBoundingRectangleSmallerThanThreshold =
          document.getElementById('root').getBoundingClientRect().top < -50;
        mobSearchInput.position = isBoundingRectangleSmallerThanThreshold ? 'fixed' : 'relative';
        mobSearchInput.top = isBoundingRectangleSmallerThanThreshold ? '45px' : '0';
      }
    };
    window.addEventListener('scroll', scrollEventListener);
    return () => window.removeEventListener('scroll', scrollEventListener);
  }, []);

  const menuNavigation = (categoryName, url) => {
    menuNavigationAnalyticsData(categoryName, 0);
    if (window?.history?.replaceState) {
      window.history.replaceState('', categoryName, `/menu/${url}`);
    } else {
      history.push({
        pathname: `/menu/${url}`,
      });
    }
  };

  const handleSetActive = param => {
    if (document.querySelector('li > a.active')) {
      document.querySelector('li > a.active').scrollIntoView({ inline: 'center' });
    }
    setActiveMenuSelection(() => param);
  };
  useEffect(() => {
    let onScrollEventMobile = setTimeout(() => {
      if (menuGtmEventTriggered !== activeMenuSelection) {
        const { selectedCategory, selectedSubcategory } = getCategoryFromSubCategory(menu, activeMenuSelection);
        let productList = getAnalytictsPayloadConditionaly(
          selectedCategory,
          selectedSubcategory,
          selectedCategory?.name,
          selectedCategory?.id,
          tenantData?.currencyConversionFactor,
        );
        vieItemListAnalytics(productList);
        setmenuGtmEventTriggered(() => activeMenuSelection);
      }
    }, 300);
    return () => {
      clearTimeout(onScrollEventMobile);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuSelection]);

  const searchModeElmnt = () => {
    return (
      <>
        <div className='no-mob-search-found-plp'>
          <span>{translateWithI18Next(YOUR_SEARCH_TEXT)}</span>
          <span className='no-search-found-text-highlighted'>{` '${searchMode.searchedData}' `}</span>
          <p>{translateWithI18Next(TURNED_NO_RESULTS_TEXT)}</p>
          <ButtonComp className='back-to-menu-plpsearch' data-testid='back-to-menu' onClick={clearSearch}>
            {translateWithI18Next(BACK_TO_MENU)}
          </ButtonComp>
        </div>
        {!!recommendProducts.length && (
          <div className='carousal-menu-container'>
            <div className='d-flex position-relative'>
              <div className='carousal-header'>{translateWithI18Next(MENU_PLP_CONSTANT.CAROUSAL_HEADER)}</div>
              <div className='card-counter'>
                {carouselCount}/{recommendProducts.length}
              </div>
            </div>
            <MenuItemList
              productList={recommendProducts}
              cardType={'carousal'}
              tenantData={tenantData}
              cardCount={getCardCount}
              categoryId={'CAT86'}
              catalogs={catalogs}
              storeClosedData={storeClosedData}
              setShowTopScrollBtn={setShowTopScrollBtn}
            />
          </div>
        )}
        <div className='horizontalLineBorder-noData'></div>
      </>
    );
  };
  const renderItemList = (productsList, subcategoriesList, cType, catDetails) => {
    const { categoryId, categoryName, categoryUrl } = catDetails;
    if (cType === VIEWUP) {
      cType = viewUp ? 'small' : 'carousal';
    }

    return subcategoriesList && subcategoriesList.length ? (
      <MenuSubCategoryItemList
        subCategory={subcategoriesList}
        cardType={cType}
        tenantData={tenantData}
        catalogs={catalogs}
        storeClosedData={storeClosedData}
      />
    ) : (
      <MenuItemList
        productList={productsList}
        cardType={cType}
        tenantData={tenantData}
        cardCount={getCardCount}
        categoryId={categoryId}
        categoryName={categoryName}
        categoryUrl={categoryUrl}
        catalogs={catalogs}
        selectedCat={selectedCat}
        storeClosedData={storeClosedData}
        setShowTopScrollBtn={setShowTopScrollBtn}
      />
    );
  };

  const renderMobilePlp = () => {
    return (
      <React.Fragment>
        {displaySectionWhenThereAreNoMatchingProductForMobile(
          paramValueMobile,
          dispositionNewMobile,
          dispositionType,
          categoryStatusMobile,
          storeClosedData,
          handleClose,
        )}

        <Row
          id='mob-searchinput-id'
          data-testid='mob-searchinput-id'
          className={`mob-nav-row ${hideTopRow ? 'hide-mob-nav-row' : ''}`}
        >
          <div onClick={() => openSearchFilterMenu()} data-testid='open-search-menu' className='mob-search-input'>
            <ImageComponent srcFile={MobSearchIcon} className='mob-search-img' />
            {([...filterList, ...dietaryList].length || searchMode.isSearchedMode) && (
              <div className='totalFilterAppliedCount'>{visibleProductsCount}</div>
            )}
          </div>
          {[...filterList, ...dietaryList, ...sortByListMob].length || searchMode.isSearchedMode ? (
            <div className='filterListRowMobView'>
              <ButtonComp
                className='clearAllFilterButtonMob'
                data-testid='clear-all-handle'
                onClickHandler={(searchMode.isSearchedMode && clearSearch ) || handleClearItems}
              >
                {(searchMode.isSearchedMode && translateWithI18Next(CLEAR_SEARCH) ) || translateWithI18Next(CLEAR_ALL)}
              </ButtonComp>
              {[...filterList, ...dietaryList, ...sortByListMob].map(item => (
                <div className=''>
                  <div className='selectedFilterButtonsMob'>
                    <span className='textFilteredMob'>{item}</span>
                    <img
                      className='mlcrossMob'
                      data-testid={`clear-all-items-${item}`}
                      onClick={() => handleClearItems(item)}
                      src={DarkCloseButton}
                      alt='Clear All Items'
                    ></img>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <ul className='mob-outer-ul'>
              {menu &&
                menu.length &&
                filterNotHiddenItem(menu).length &&
                filterNotHiddenItemWithProducts({ menu, handleSetActive, menuNavigation })}
            </ul>
          )}
        </Row>

        {searchMode.isSearchedMode && visibleProductsCount > 0 ? (
          <Row className='pt-4 pl-5'>
            <h3 className='found-text'>
              {translateWithI18Next(WE_FOUND_TEXT)} {visibleProductsCount}
              {` "${searchMode.searchedData.toUpperCase()}"`}
            </h3>
          </Row>
        ) : ((([...filterList, ...dietaryList].length > 0 && visibleProductsCount === 0) && (
          <Row className='pt-4 pl-5'>
            <h2 className='found-text'>
              {WE_FOUND_TEXT} {visibleProductsCount} {'results'.toUpperCase()}
            </h2>
          </Row>
        )) || (
          [...filterList, ...dietaryList].length > 0 &&
          visibleProductsCount > 0 && (
            <Row className='pt-4 pl-5'>
              <h2 className='found-text'>
                {WE_FOUND_TEXT} {visibleProductsCount} {'results'.toUpperCase()}
              </h2>
            </Row>
          )
        ))}
        <Row data-testid='mob-search-testid' className='mob-plp-sections'>
          <Col className='mob-plp-col'>
            {!searchMode.isSearchedMode && categories && categories.length
              ? categoriesMenuItems({
                  categoriesList: categories,
                  carouselCount,
                  visibleProductsCount,
                  renderItemList,
                  viewCarousal,
                  viewUp,
                  changeViewtoUp,
                  changeViewtoCarousal,
                })
              : OnSerchElmnt({
                searchMode,
                filterList,
                dietaryList,
                products,
                viewUp,
                tenantData,
                getCardCount,
                catalogs,
                storeClosedData,
                setShowTopScrollBtn,
                searchModeElmnt,
                MenuItemList,
                CATEGORY_ID
              })}
          </Col>
        </Row>
        <MobSearchFilterMenu
          ref={mobileSearchFilterMenuRef}
          className='sidenav-filter'
          filterList={filterList}
          dietaryList={dietaryList}
          sortByListMob={sortByListMob}
          handleClearItems={handleClearItems}
          closeSearchFilterMenu={closeSearchFilterMenu}
          handleFilteredData={handleFilteredData}
          handleSearchdata={handleSearchdata}
          setSearchModeData={setSearchModeSet}
          data={data}
          inputSearchData={inputSearchData}
        />
      </React.Fragment>
    );
  };
  return renderMobilePlp();
};

function displaySectionWhenThereAreNoMatchingProductForMobile(
  paramValueMobile,
  dispositionNewMobile,
  dispositionType,
  categoryStatusMobile,
  storeClosedData,
  handleClose,
) {
  const PRODUCT_NOT_FOUND_CONSTANTS = {
    CLEAR_ALL_MSG: {
      MSGTXT1: 'categoryNotAvailable',
      MSGTXT2: 'notAvailable',
      MSGTXT3: getTernaryValue(dispositionNewMobile?.type, `for ${dispositionType}`, ''), // exploring our menu option.',
    },
    CONTINUE: 'continue',
  };

  return (
    /* Modal for error message when incorrect url for deeplink */
    getAndCheck(categoryStatusMobile, !storeClosedData?.isStoreClosed) && (
      <CartAlertFormInsideModel
        handleClose={handleClose}
        classNames='clear-cart-modal'
        CartAlertForm={
          <CartAlertForm
            splitTitle={PRODUCT_NOT_FOUND_CONSTANTS.CLEAR_ALL_MSG}
            imageSrc={Cart_Error}
            altText={'cart-error'}
            confirmButtonText={translateWithI18Next(PRODUCT_NOT_FOUND_CONSTANTS?.CONTINUE)}
            confirmHandler={handleClose}
          />
        }
      />
    )
  );
}
